import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Calendar } from 'lucide-react';

export const InfluencerCouponsTab = ({ clientCoupons }) => (
  <div className="space-y-6">
    <h2 className="text-xl font-bold text-slate-900">Todos os Cupons Ativos</h2>
    {clientCoupons.length > 0 ? (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {clientCoupons.map(c => (
          <Card key={c.coupon_id} className="bg-white border border-slate-200 hover:shadow-md transition-shadow" data-testid={`coupon-card-${c.coupon_id}`}>
            {c.images?.length > 0 && (
              <div className="w-full aspect-[4/3] overflow-hidden rounded-t-lg">
                <img src={c.images[0]} alt={c.title} className="w-full h-full object-cover" />
              </div>
            )}
            <CardContent className="pt-4">
              <div className="flex justify-between items-start mb-2">
                <Badge className="bg-red-500 text-white border-0">{c.discount_percentage}% OFF</Badge>
                <Badge className="bg-slate-100 text-slate-700 border-slate-200 text-xs">{c.category}</Badge>
              </div>
              <h3 className="text-base font-bold text-slate-900 mb-1">{c.title}</h3>
              <p className="text-sm text-slate-600 line-clamp-2 mb-2">{c.description}</p>
              <div className="flex justify-between text-xs text-slate-500">
                <span>{c.merchant_name}</span>
                <span><Calendar className="h-3 w-3 inline mr-1" />{c.expiry_date ? new Date(c.expiry_date).toLocaleDateString('pt-BR') : '-'}</span>
              </div>
              <div className="flex justify-between mt-2 pt-2 border-t border-slate-100 text-xs">
                <span className="text-blue-600 font-bold">{c.current_uses || 0} usos</span>
                <span className="text-green-600 font-bold">{c.total_claims || 0} resgates</span>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    ) : (
      <Card className="bg-white border border-slate-200"><CardContent className="py-12 text-center">
        <p className="text-slate-500">Nenhum cupom ativo no momento</p>
      </CardContent></Card>
    )}
  </div>
);
